import { DefaultState } from 'store/types';

export const SEARCH_RESERVATION_REQUEST = 'SEARCH_RESERVATION_REQUEST';
export const SEARCH_RESERVATION_SUCCESS = 'SEARCH_RESERVATION_SUCCESS';
export const SEARCH_RESERVATION_FAILURE = 'SEARCH_RESERVATION_FAILURE';

export interface SearchReservationParams {
  filters: {
    searchString: string;
  },
  paging: {
    page: number;
    pageSize: number;
  }
};

export interface SearchReservationDataRow {
  id: string;
  address: string;
  lodgingType: string;
  name: string;
};

export interface SearchReservationData {
  rows: SearchReservationDataRow[];
  totalCount: number;
};

export type SearchReservationState = DefaultState & {
  contents?: SearchReservationData;
};

interface SearchReservationRequest {
  type: typeof SEARCH_RESERVATION_REQUEST;
};

interface SearchReservationSuccess {
  type: typeof SEARCH_RESERVATION_SUCCESS,
  contents: SearchReservationData;
}

interface SearchReservationFailure {
  type: typeof SEARCH_RESERVATION_FAILURE;
}

export type SearchReservationActionTypes = SearchReservationRequest | SearchReservationSuccess | SearchReservationFailure;